/* tslint:disable */
/* eslint-disable */
/**
 * Assisted Webservices
 * Enables agents to provide real-time support to customers. For example, agents are able to find a customer account or cart, bind anonymous carts to customer accounts, and provide different customer lists relative to different business applications.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Language
 * @export
 * @interface Language
 */
export interface Language {
    /**
     * iso code of the language
     * @type {string}
     * @memberof Language
     */
    isocode?: string;
    /**
     * name of the language
     * @type {string}
     * @memberof Language
     */
    name?: string;
    /**
     * name the language in native form
     * @type {string}
     * @memberof Language
     */
    nativeName?: string;
    /**
     * true/false indicator when the language is active
     * @type {boolean}
     * @memberof Language
     */
    active?: boolean;
}

/**
 * Check if a given object implements the Language interface.
 */
export function instanceOfLanguage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LanguageFromJSON(json: any): Language {
    return LanguageFromJSONTyped(json, false);
}

export function LanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Language {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isocode': !exists(json, 'isocode') ? undefined : json['isocode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'nativeName': !exists(json, 'nativeName') ? undefined : json['nativeName'],
        'active': !exists(json, 'active') ? undefined : json['active'],
    };
}

export function LanguageToJSON(value?: Language | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isocode': value.isocode,
        'name': value.name,
        'nativeName': value.nativeName,
        'active': value.active,
    };
}

